import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { AlertService } from "src/app/providers/alert.service";
import { AuthService } from "src/app/providers/auth.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { SharedEventService } from "src/app/services/shared-event.service";
import { CustomConfirmDialogComponent } from "src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { environment } from "src/environments/environment";
declare const paypal: any;

@Component({
  selector: "sm-paypal-employee-subscription-purchase",
  templateUrl: "./paypal-employee-subscription-purchase.component.html",
  styleUrls: ["./paypal-employee-subscription-purchase.component.scss"],
})
export class PaypalEmployeeSubscriptionPurchaseComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  @Input() parentdata: any;
  isloader: boolean = true;
  @Output() close = new EventEmitter<void>();
  constructor(
    private authService: AuthService,
    private ls: LoaderServiceService,
    private alertservice: AlertService,
    private _modelRef: MatDialog,
    private eventService: SharedEventService
  ) {}

  ngOnInit(): void {
    console.log("parentdata::::>>>", this.parentdata);
  }

  ngAfterViewInit() {
    // this.renderPayPalButton();
    const merchantId = environment.paypal_merchant_id;
    this.loadPayPalScript(merchantId)
      .then(() => {
        this.isloader = false;
        this.renderPayPalButton();
      })
      .catch((err) => {
        console.error(err);
        this.alertservice.onOpenSnackbar("Failed to load PayPal SDK", 4000);
      });
  }

  renderPayPalButton() {
    paypal
      .Buttons({
        createOrder: async (data: any, actions: any) => {
          const token = await this.authService.getToken();
          const parentdata = this.parentdata;

          return fetch(
            `https://transaction-services.lookzup.com/${environment.stage}/v2/createInternationalSubscriptionOrder`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
              body: JSON.stringify(this.parentdata),
            }
          )
            .then((res) => res.json())
            .then((res) => res.orderID);
        },
        onApprove: async (data: any) => {
          console.log("onApprovedata:::>>>>>", data);
          // this.ls.showLoader = true
          const token = await this.authService.getToken();
          const parentdata = this.parentdata;
          return fetch(
            `https://transaction-services.lookzup.com/${environment.stage}/v2/captureInternationalSubscriptionOrderRequest`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
              body: JSON.stringify({
                orderId: data.orderID,
                account_hash_id: localStorage.getItem(
                  SM_CONSTANTS.KEY_ACCOUNT_HASH_ID
                ),
                // entityHash: parentdata.entity_hash_id,
                // invoiceHash: parentdata.hash_id,
                // is_paying_due: parentdata.total_price == parentdata.payment_due ? 0 : 1,
                // payment_time: this.formatDateString()
              }),
            }
          )
            .then((res) => res.json())
            .then((res) => {
              if (res.errorcode == "0") {
                console.log("afterApproved:::>>>>", res);
                this.alertservice.onOpenSnackbar("Payment successful.", 3000);
                this.eventService.emitCloseSheet({
                  msg: "success",
                });

                this.closeSheet("success");
              } else {
                console.log("afterApprovedWithError:::>>>>", res);
                const dialogRef = this._modelRef.open(
                  CustomConfirmDialogComponent,
                  {
                    width: "400px",
                    data: {
                      title: "Error!",
                      message: res.msg,
                      okbtn: "Ok",
                      cancelbtn: "Cancel",
                      type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
                    },
                    disableClose: true,
                  }
                );

                this.closeSheet();
              }
            });
        },
        onCancel: async (data: any, actions: any) => {
          console.log("payment cancel data", data);
          this.alertservice.onOpenSnackbar("Payment cancelled.", 3000);

          this.closeSheet();
        },
        onError: async (data: any, actions: any) => {
          console.log("payment error data", data);
          this.alertservice.onOpenSnackbar("Error in payment.", 5000);

          this.closeSheet();
        },
      })
      .render("#paypal-button-container");
  }

  closeSheet(data?: any) {
    this.close.emit(data);
  }

  loadPayPalScript(merchantId: string): Promise<void> {
    return new Promise((resolve, reject) => {
      if (document.getElementById("paypal-sdk")) {
        resolve(); // Already loaded
        return;
      }

      const script = document.createElement("script");
      script.id = "paypal-sdk";
      script.src = `https://www.paypal.com/sdk/js?client-id=${environment.paypal_client_id}&merchant-id=${merchantId}&enable-funding=venmo,paylater`;
      script.setAttribute("data-partner-attribution-id", "LogicasanaPvtLtd_SP");
      script.onload = () => resolve();
      script.onerror = () => reject("PayPal SDK failed to load");
      document.body.appendChild(script);
    });
  }

  ngOnDestroy(): void {
    const existingScript = document.getElementById("paypal-sdk");
    if (existingScript) {
      existingScript.remove();
    }
  }

  formatDateString(): string {
    const now = new Date();

    const options: Intl.DateTimeFormatOptions = {
      timeZone: "Asia/Kolkata",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false, // Ensures 24-hour format
    };

    const formattedDate = new Intl.DateTimeFormat(
      "en-CA",
      options
    ).formatToParts(now);

    let year = "",
      month = "",
      day = "",
      hours = "",
      minutes = "",
      seconds = "";

    formattedDate.forEach((part) => {
      if (part.type === "year") year = part.value;
      if (part.type === "month") month = part.value;
      if (part.type === "day") day = part.value;
      if (part.type === "hour") hours = part.value;
      if (part.type === "minute") minutes = part.value;
      if (part.type === "second") seconds = part.value;
    });

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }
}
